import {Settings} from "src/pages/DashboardPage/vpo/types/data";

export enum StrapiActionTypes {
  FETCH_REQUEST_GOS = 'strapi/FETCH_REQUEST_GOS',
  FETCH_SUCCESS_GOS = 'strapi/FETCH_SUCCESS_GOS',
  FETCH_FAILURE_GOS = 'strapi/FETCH_FAILURE_GOS',

  ADD_REQUEST_GOS = 'ADD_REQUEST_GOS',
  ADD_SUCCESS_GOS = 'ADD_SUCCESS_GOS',
  ADD_FAILURE_GOS = 'ADD_FAILURE_GOS',

  UPDATE_REQUEST_GOS = 'UPDATE_REQUEST_GOS',
  UPDATE_SUCCESS_GOS = 'UPDATE_SUCCESS_GOS',
  UPDATE_FAILURE_GOS = 'UPDATE_FAILURE_GOS',

  SET_LAST_DOC_ID_GOS = 'SET_LAST_DOC_ID_GOS',

  SET_LAST_ADDED_ID_GOS = 'SET_LAST_ADDED_ID_GOS',

  SET_LAST_UPDATED_ID_GOS = 'SET_LAST_UPDATED_ID_GOS',

  DELETE_REQUEST_GOS = 'DELETE_REQUEST_GOS',
  DELETE_SUCCESS_GOS = 'DELETE_SUCCESS_GOS',
  DELETE_FAILURE_GOS = 'DELETE_FAILURE_GOS',
}

export type AdminSettings = {
  data: Settings[];
  fetchingStatusSettings: boolean;
  error: null;
}

export interface StrapiItem {
  id: number;
  documentId?: string;
  [key: string]: any;
}

export interface StrapiState {
  [modelName: string]: {
    data?: any[];
    loading?: boolean;
    error?: string | null;
    lastAddedId?: number | null;
    lastUpdatedId?: number | null;
    lastDocId?: string | null;
    lastAddedCreatorId?: string | null;
    actionByContext?: {
      data: any[];
      loading: boolean;
      error: string | null;
    };
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export interface FetchRequestAction {
  type: StrapiActionTypes.FETCH_REQUEST_GOS;
  payload: {
    modelName: string;
    params?: any;
    pagination?: {
      page: number;
      pageSize: number;
    };
    append?: boolean;
  };
}

export interface FetchFailureAction {
  type: StrapiActionTypes.FETCH_FAILURE_GOS;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface FetchSuccessAction {
  type: StrapiActionTypes.FETCH_SUCCESS_GOS;
  payload: {
    modelName: string;
    data: StrapiItem[];
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
    append?: boolean;
  };
}

export interface AddRequestAction {
  type: StrapiActionTypes.ADD_REQUEST_GOS;
  payload: {
    modelName: string;
    data: any;
    creatorId?: string;
  };
}

export interface AddSuccessAction {
  type: StrapiActionTypes.ADD_SUCCESS_GOS;
  payload: {
    modelName: string;
    data: StrapiItem;
    creatorId?: string;
  };
}

export interface AddFailureAction {
  type: StrapiActionTypes.ADD_FAILURE_GOS;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface UpdateRequestAction {
  type: StrapiActionTypes.UPDATE_REQUEST_GOS;
  payload: {
    modelName: string;
    documentId: string;
    data: any;
  };
}

export interface UpdateSuccessAction {
  type: StrapiActionTypes.UPDATE_SUCCESS_GOS;
  payload: {
    modelName: string;
    data: StrapiItem;
  };
}

export interface UpdateFailureAction {
  type: StrapiActionTypes.UPDATE_FAILURE_GOS;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface SetLastDocIdAction {
  type: StrapiActionTypes.SET_LAST_DOC_ID_GOS;
  payload: {
    modelName: string;
    documentId: string | null;
  };
}

export interface SetLastAddedIdAction {
  type: StrapiActionTypes.SET_LAST_ADDED_ID_GOS;
  payload: {
    modelName: string;
    id: number | null;
  };
}

export interface SetLastUpdatedIdAction {
  type: StrapiActionTypes.SET_LAST_UPDATED_ID_GOS;
  payload: {
    modelName: string;
    id: number | null;
  };
}

export interface DeleteRequestAction {
  type: StrapiActionTypes.DELETE_REQUEST_GOS;
  payload: {
    modelName: string;
    documentId: string;
  };
}

export interface DeleteSuccessAction {
  type: StrapiActionTypes.DELETE_SUCCESS_GOS;
  payload: {
    modelName: string;
    documentId: string;
  };
}

export interface DeleteFailureAction {
  type: StrapiActionTypes.DELETE_FAILURE_GOS;
  payload: {
    modelName: string;
    error: string;
  };
}

export type StrapiActions =
  | FetchRequestAction
  | FetchSuccessAction
  | FetchFailureAction
  | AddRequestAction
  | AddSuccessAction
  | AddFailureAction
  | UpdateRequestAction
  | UpdateSuccessAction
  | UpdateFailureAction
  | SetLastDocIdAction
  | SetLastAddedIdAction
  | SetLastUpdatedIdAction
  | DeleteRequestAction
  | DeleteSuccessAction
  | DeleteFailureAction;
